import { formatNumbers } from '../../utils/convert-to-arabic-price';
import RIYALIcon from '../../assets/riyal.svg?react';
import { Product } from '../../types/product';
import { ProductCardConfig } from '../../types/product-card';

import FavoriteIcon1 from '../../assets/favorite/favorite1.svg?react';
import FavoriteIcon2 from '../../assets/favorite/favorite2.svg?react';
import FavoriteIcon3 from '../../assets/favorite/favorite3.svg?react';
import FavoriteIcon4 from '../../assets/favorite/favorite4.svg?react';
import FavoriteIcon5 from '../../assets/favorite/favorite5.svg?react';

import AddToCartIcon1 from '../../assets/add-to-cart/add-to-cart1.svg?react';
import AddToCartIcon2 from '../../assets/add-to-cart/add-to-cart2.svg?react';
import AddToCartIcon3 from '../../assets/add-to-cart/add-to-cart3.svg?react';
import AddToCartIcon4 from '../../assets/add-to-cart/add-to-cart4.svg?react';
import AddToCartIcon5 from '../../assets/add-to-cart/add-to-cart5.svg?react';

interface ProductCardProps {
  color?: string;
  currency?: string;
  product?: Product;
  config?: ProductCardConfig;
  handleProductClick?: (product: Product) => Promise<void>;
  toggleFavorites?: (product: Product) => Promise<void>;
  handleAddToCart?: (product: Product) => Promise<void>;
  loadingStates?: Record<string, boolean>;
  preview?: boolean;
  type?: 'search-page' | 'recommendation';
  showDiscounts?: boolean;
  language?: string;
}

const ProductCard: React.FC<ProductCardProps> = ({
  config,
  //   color = 'black',
  currency = 'SAR',
  language = 'ar',
  product = {
    id: 1,
    name: { ar: 'Product 1', en: 'Product 1' },
    url: 'https://www.google.com',
    mainImage:
      'https://d2v5dzhdg4zhx3.cloudfront.net/web-assets/images/storypages/primary/ProductShowcasesampleimages/JPEG/Product+Showcase-1.jpg',
    price: 100,
    discountedPrice: 80,
    isAvailable: true,
    productId: 1,
    categories: [{ name: { ar: 'Default', en: 'Default' } }],
    currency: 'SAR',
    description: { ar: 'Product 1 description', en: 'Product 1 description' },
    is_available: true,
    media: [],
    parent_id: 0,
    promotion_title: { ar: '', en: '' },
    quantity: 1,
    sku: '',
    status: 'active',
    store: {
      description: '',
      id: 1,
      name: '',
      route_key: '',
      store_id: '1',
    },
    store_id: 1,
    subtitle: { ar: '', en: '' },
    tags: [],
    type: 'product',
    unlimited_quantity: false,
    weight: 0,
    weight_type: 'kg',
    badges: { ar: '', icon: '' },
  } as Product,
  handleProductClick,
  toggleFavorites,
  handleAddToCart,
  loadingStates,
  preview = false,
  type = 'search-page',
  showDiscounts = true,
}) => {
  //   const primaryColor = color;

  const addToCartIcon = () => {
    const iconSize = config?.addToCartIconSize || '24px';
    const iconColor = config?.addToCartIconColor || 'currentColor';

    switch (config?.addToCartIcon) {
      case '1':
        return (
          <AddToCartIcon1
            width={iconSize}
            height={iconSize}
            style={{
              color: iconColor,
              marginInlineEnd: '8px',
            }}
          />
        );
      case '2':
        return (
          <AddToCartIcon2
            width={iconSize}
            height={iconSize}
            style={{
              fill: iconColor,
              marginInlineEnd: '8px',
            }}
          />
        );
      case '3':
        return (
          <AddToCartIcon3
            width={iconSize}
            height={iconSize}
            style={{
              fill: iconColor,
              marginInlineEnd: '8px',
            }}
          />
        );
      case '4':
        return (
          <AddToCartIcon4
            width={iconSize}
            height={iconSize}
            style={{
              fill: iconColor,
              marginInlineEnd: '8px',
            }}
          />
        );
      case '5':
        return (
          <AddToCartIcon5
            width={iconSize}
            height={iconSize}
            style={{
              color: iconColor,
              marginInlineEnd: '8px',
            }}
          />
        );
      default:
        return (
          <AddToCartIcon1
            width={iconSize}
            height={iconSize}
            style={{
              color: iconColor,
              marginInlineEnd: '8px',
            }}
          />
        );
    }
  };

  const wishlistIcon = () => {
    switch (config?.wishlistIcon) {
      case '1':
        return (
          <FavoriteIcon1
            width={config?.wishlistIconSize}
            height={config?.wishlistIconSize}
            fill={config?.wishlistIconColor}
          />
        );
      case '2':
        return (
          <FavoriteIcon2
            width={config?.wishlistIconSize}
            height={config?.wishlistIconSize}
            fill={config?.wishlistIconColor}
          />
        );
      case '3':
        return (
          <FavoriteIcon3
            width={config?.wishlistIconSize}
            height={config?.wishlistIconSize}
            fill={config?.wishlistIconColor}
          />
        );
      case '4':
        return (
          <FavoriteIcon4
            width={config?.wishlistIconSize}
            height={config?.wishlistIconSize}
            fill={config?.wishlistIconColor}
          />
        );
      case '5':
        return (
          <FavoriteIcon5
            width={config?.wishlistIconSize}
            height={config?.wishlistIconSize}
            fill={config?.wishlistIconColor}
          />
        );
      default:
        return (
          <FavoriteIcon1
            width={config?.wishlistIconSize}
            height={config?.wishlistIconSize}
            fill={config?.wishlistIconColor}
          />
        );
    }
  };

  // Check if we're on mobile and in search-page mode
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 767;
  const shouldUseFullWidth = type !== 'recommendation' && isMobile;

  return (
    <div
      key={product.id}
      className={`alfinder-product-card-entry alfinder-product-card-vertical ${
        type === 'recommendation' ? 'embla__slide' : ''
      }`}
      style={{
        width: shouldUseFullWidth ? 'none' : config?.productCardWidth,
        borderRadius: config?.productCardBorderRadius,
        ...(type === 'recommendation' && {
          paddingLeft: '1rem',
          flex: `0 0 ${config?.productCardWidth}`,
        }),
        backgroundColor:
          type === 'recommendation' ? 'transparent' : 'rgba(255, 255, 255, 1)',
      }}
    >
      <div
        className="alfinder-product-card-image"
        style={
          {
            '--product-card-image-border-radius':
              config?.productCardBorderRadius,
            height: config?.productCardImageHeight,
          } as React.CSSProperties
        }
      >
        <a
          href={product.url}
          onClick={async (e) => {
            e.preventDefault();
            if (!preview) {
              handleProductClick?.(product);
            }
          }}
        >
          <img
            className="alfinder-product-card-image-cover lazy loaded"
            style={
              {
                '--product-card-image-border-radius':
                  config?.productCardBorderRadius,
                height: config?.productCardImageHeight,
              } as React.CSSProperties
            }
            src={product.mainImage}
            alt={product.name.ar}
            loading="lazy"
          />
        </a>
        {/* {provider === 'salla' ? (
          <button
            color="light"
            className="alfinder-product-card-wishlist-btn"
            aria-label="Add or remove to wishlist"
            // onClick={() => toggleFavorites(product)}
          >
            <button className="wishlist-icon-button">
              <span className="wishlist-icon-wrapper">
                <i className="sicon-heart"></i>
              </span>
            </button>
          </button>
        ) : ( */}
        {config?.showWishlistIcon &&
          (config?.wishlistIconPosition === 'top-left' ||
            config?.wishlistIconPosition === 'top-right') && (
            <button
              className="alfinder-wishlist-icon-button"
              aria-label="Add or remove to wishlist"
              style={{
                left:
                  config?.wishlistIconPosition === 'top-left'
                    ? '0.75rem'
                    : 'unset',
                right:
                  config?.wishlistIconPosition === 'top-right'
                    ? '0.75rem'
                    : 'unset',
              }}
              onClick={() => {
                if (!preview) {
                  toggleFavorites?.(product);
                }
              }}
            >
              <span className="alfinder-wishlist-icon-wrapper">
                {wishlistIcon()}
              </span>
            </button>
          )}
        {/* )} */}
      </div>

      <div
        className="alfinder-product-card-content"
        style={{
          backgroundColor: config?.productCardContentBackgroundColor,
          padding: config?.productCardContentPadding,
          border: `${config?.productCardContentBorderWidth} solid ${config?.productCardContentBorderColor}`,
          borderTop: 'none',
          height: config?.productCardContentHeight,
          borderBottomLeftRadius: config?.productCardBorderRadius,
          borderBottomRightRadius: config?.productCardBorderRadius,
          direction: language === 'ar' ? 'rtl' : 'ltr',
        }}
      >
        <div className="alfinder-product-card-content-main">
          <h3 className="alfinder-product-card-content-title">
            <a
              href={
                language === 'ar'
                  ? product.urlTrans?.ar
                  : product.urlTrans?.en || product.urlTrans?.ar
              }
              title={
                language === 'ar'
                  ? product.name.ar
                  : product.name.en || product.name.ar
              }
              onClick={async (e: React.MouseEvent<HTMLAnchorElement>) => {
                e.preventDefault();
                if (!preview) {
                  handleProductClick?.(product);
                }
              }}
            >
              {language === 'ar'
                ? product.name.ar
                : product.name.en || product.name.ar}
            </a>
          </h3>
        </div>

        <div className="alfinder-product-card-content-sub">
          <h4 className="alfinder-product-card-price">
            {product.discountedPrice && showDiscounts ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginInlineEnd: '6px',
                    color: config?.productCardContentPriceColor,
                  }}
                >
                  <div
                    style={{
                      fontSize: '0.875rem',
                      marginInlineEnd: '1px',
                    }}
                  >
                    {formatNumbers(
                      product.discountedPrice,
                      config?.productCardEnableEnglishPrices
                        ? 'en-US'
                        : 'ar-SA',
                      currency,
                    )}
                  </div>
                  {currency === 'SAR' && (
                    <RIYALIcon fill={config?.productCardContentPriceColor} />
                  )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'line-through',
                    color: config?.productCardContentPriceBeforeDiscountColor,
                  }}
                >
                  <div
                    style={{
                      fontSize: '0.875rem',
                      marginInlineEnd: '1px',
                    }}
                  >
                    {formatNumbers(
                      product.price,
                      config?.productCardEnableEnglishPrices
                        ? 'en-US'
                        : 'ar-SA',
                      currency,
                    )}
                  </div>
                  {currency === 'SAR' && (
                    <RIYALIcon
                      fill={config?.productCardContentPriceBeforeDiscountColor}
                    />
                  )}
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    fontSize: '0.875rem',
                    marginInlineEnd: '1px',
                    color: config?.productCardContentPriceColor,
                  }}
                >
                  {formatNumbers(
                    product.price,
                    config?.productCardEnableEnglishPrices ? 'en-US' : 'ar-SA',
                    currency,
                  )}
                </div>
                {currency === 'SAR' && (
                  <RIYALIcon fill={config?.productCardContentPriceColor} />
                )}
              </div>
            )}
          </h4>
        </div>

        <div className="alfinder-product-card-content-footer">
          {/* <button
            style={{
              width: '100%',
              border: 'none',
              background: 'none',
            }}
          > */}
          <div style={{ width: '100%' }}>
            {product.isAvailable ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px',
                }}
              >
                {config?.showWishlistIcon &&
                  config?.wishlistIconPosition === 'bottom-right' && (
                    <button
                      aria-label="Add or remove to wishlist"
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        if (!preview) {
                          toggleFavorites?.(product);
                        }
                      }}
                    >
                      <span className="alfinder-wishlist-icon-wrapper">
                        {wishlistIcon()}
                      </span>
                    </button>
                  )}
                <button
                  className="alfinder-add-to-cart-button"
                  style={
                    {
                      backgroundColor:
                        config?.addToCartButtonType === 'filled'
                          ? config?.addToCartButtonColor
                          : 'transparent',
                      borderColor: config?.addToCartButtonColor,
                      color: config?.addToCartButtonTextColor,
                      borderRadius: config?.addToCartButtonBorderRadius,
                      width: config?.addToCartButtonWidth,
                      height: config?.addToCartButtonHeight,
                      '--hover-background-color':
                        config?.addToCartButtonHoverColor,
                      border:
                        config?.addToCartButtonType === 'outlined'
                          ? `1px solid ${config?.addToCartButtonColor}`
                          : 'none',
                    } as React.CSSProperties
                  }
                  onClick={() => {
                    if (!preview) {
                      handleAddToCart?.(product);
                    }
                  }}
                  disabled={loadingStates?.[product.productId]}
                  type="button"
                >
                  {loadingStates?.[product.productId] ? (
                    <span
                      className="loader-alfinder-add-to-cart"
                      style={{
                        border: `3px solid ${config?.addToCartButtonTextColor}`,
                        borderBottomColor: 'transparent',
                        borderRadius: '50%',
                      }}
                    ></span>
                  ) : (
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {config?.showAddToCartIcon && addToCartIcon()}
                      <span>
                        {language === 'ar'
                          ? config?.addToCartButtonText
                          : config?.addToCartButtonTextEn}
                      </span>
                    </span>
                  )}
                </button>
                {config?.showWishlistIcon &&
                  config?.wishlistIconPosition === 'bottom-left' && (
                    <button
                      aria-label="Add or remove to wishlist"
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        if (!preview) {
                          toggleFavorites?.(product);
                        }
                      }}
                    >
                      <span className="alfinder-wishlist-icon-wrapper">
                        {wishlistIcon()}
                      </span>
                    </button>
                  )}
              </div>
            ) : (
              <span
                style={{
                  color: '#ad1a10',
                  flex: '1',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'default',
                  height: config?.addToCartButtonHeight,
                  // color: config?.addToCartButtonTextColor,
                }}
              >
                <span>
                  {language === 'ar'
                    ? config?.addToCartButtonOutOfStockText
                    : config?.addToCartButtonOutOfStockTextEn}
                </span>
              </span>
            )}
          </div>
          {/* </button> */}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
